module.exports = fox._r("images/social_icons/ico-bz.png", __webpack_public_path__ + "_/_/_/root/images/social_icons/ico-bz.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/social_icons/ico-bz.png
// module id = 940
// module chunks = 4